import { authentication, isInternal } from '@ecosystem/newron-client-lib';

interface ImpersonationHeader {
  'X-Impersonate-Client': string;
}

const IMPERSONATION_STORAGE_KEY = 'impersonation';

/**
 * Returns the impersonation header to use for API calls.
 */
export function getImpersonationHeader(): ImpersonationHeader | null {
  const isInternalUser = isInternal(authentication.getUser());
  if (!isInternalUser) {
    return null;
  }

  const storage = localStorage.getItem(IMPERSONATION_STORAGE_KEY);
  if (storage) {
    return {
      'X-Impersonate-Client': storage,
    };
  }

  return null;
}
